import { useState, useEffect, FocusEvent } from 'react';

const formatValue = (val: number) => {
  if (val === 0) return '';
  const m = Math.floor(val / 60);
  const s = (val % 60).toString().padStart(2, '0');
  return `${m}:${s}`;
};

export function TimeInput({
  value,
  onChange,
  onValidityChange,
}: {
  value: number;
  onChange: (_newValue: number) => void;
  onValidityChange?: (_valid: boolean) => void;
}) {
  const [display, setDisplay] = useState(() => formatValue(value));
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid]);

  const parseValue = (e: FocusEvent<HTMLInputElement>) => {
    if (!e.target.value.trim()) {
      setIsValid(false);
      return;
    }

    const regex = /^\d+:?\d{0,2}$/;
    if (!regex.test(e.target.value)) {
      setIsValid(false);
      return;
    }

    const [minStr, secStr = '0'] = e.target.value.split(':');
    const min = parseInt(minStr);
    const sec = parseInt(secStr);

    if (
      !isNaN(min) &&
      !isNaN(sec) &&
      sec < 60 &&
      min >= 0 &&
      (sec > 0 || min > 0)
    ) {
      setIsValid(true);
      onChange(min * 60 + sec);
    } else {
      setIsValid(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setDisplay(val);
  };

  return (
    <input
      type="text"
      value={display}
      onChange={handleChange}
      onBlur={parseValue}
      className={`border p-2 w-full ${isValid ? '' : 'border-red-500'}`}
      placeholder="Enter time (e.g. 5:30, 120:00)"
    />
  );
}
